import { ProjectType } from '@shared/models';

export const PROJECT_TYPE_DESCRIPTION_KEYS: Record<ProjectType, string> = {
  [ProjectType.Other]: 'project.createProjectModal.typeStep.descriptions.other',
  [ProjectType.NewBuilding]: 'project.createProjectModal.typeStep.descriptions.newBuilding',
  [ProjectType.Renovation]: 'project.createProjectModal.typeStep.descriptions.renovation',
  [ProjectType.Service]: 'project.createProjectModal.typeStep.descriptions.service',
  [ProjectType.MasterProject]: 'project.createProjectModal.typeStep.descriptions.masterProject',
};

export const PROJECT_TYPE_ICONS: Record<ProjectType, string> = {
  [ProjectType.Other]: 'pi-th-large',
  [ProjectType.NewBuilding]: 'pi-building',
  [ProjectType.Renovation]: 'pi-hammer',
  [ProjectType.Service]: 'pi-wrench',
  [ProjectType.MasterProject]: 'pi-sitemap',
};

export const DEFAULT_WORKING_HOURS_PER_WEEK = 40;
